(function(){
  document.documentElement.classList.remove('no-js');
  var root = document.documentElement;
  var THEMES = { patrol: "Patrol Blue", nightwatch: "Night Watch" };
  function current(){ return root.getAttribute('data-theme') || 'patrol'; }
  var btn = document.getElementById('theme-toggle');
  function paint(){
    if(!btn) return;
    var next = current() === 'patrol' ? 'nightwatch' : 'patrol';
    btn.textContent = "\u25C9 " + THEMES[next];
    btn.setAttribute('aria-label', 'Switch to the ' + THEMES[next] + ' theme');
  }
  paint();
  if(btn){
    btn.addEventListener('click', function(){
      var c = current() === 'patrol' ? 'nightwatch' : 'patrol';
      root.setAttribute('data-theme', c);
      try { localStorage.setItem('dawg-theme', c); } catch(e){}
      paint();
    });
  }
  var mb = document.querySelector('.menu-btn');
  var mn = document.getElementById('MobileNav');
  if(mb && mn){
    mb.addEventListener('click', function(){
      var open = mn.classList.toggle('open');
      mb.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      var m = document.getElementById('ProductMainImage');
      if(m) m.src = t.getAttribute('data-full');
    });
  });
})();
